import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/axiosAuth";

export const fetchPOSBranches = createAsyncThunk(
  "api/POSBranches/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`/api/POSBranches`);
      return { rows: response.data || [] };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const POSBranchesSlice = createSlice({
  name: "POSBranches",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPOSBranches.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPOSBranches.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload.rows;
      })
      .addCase(fetchPOSBranches.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default POSBranchesSlice.reducer;
export const selectPOSBranchesRows = (state) => state.POSBranches.rows;
export const selectPOSBranchesStatus = (state) => state.POSBranches.status;
export const selectPOSBranchesError = (state) => state.POSBranches.error;
